import { render, staticRenderFns } from "./IndexCommunity.vue?vue&type=template&id=447450ee"
import script from "./IndexCommunity.vue?vue&type=script&lang=js"
export * from "./IndexCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports